import React from 'react';
import styles from './Badge.module.css';

const Badge = ({
  children,
  variant = 'neutral',
  className = '',
  style = {}
}) => {
  const variantClass = styles[variant] || styles.neutral;

  return (
    <span
      style={style}
      className={`${styles.badge} ${variantClass} ${className}`.trim()}
    >
      {children}
    </span>
  );
};

export default Badge;
